<template>
  <b-container fluid class="no-sided-margin">

    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="2">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Filtri</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form @submit="findFiltered">
              <b-form-group label="Codice Cliente">
                <b-form-input v-model="filters.customerKey"/>
              </b-form-group>
              <b-form-group label="Codice Negozio">
                <b-form-input v-model="filters.storeKey"/>
              </b-form-group>
              <b-form-group label="Nome Sensei">
                <b-form-input v-model="filters.displayName"/>
              </b-form-group>
              <b-form-group label="Email">
                <b-form-input v-model="filters.email"/>
              </b-form-group>
              <b-form-group label="Numero di Telefono">
                <b-form-input v-model="filters.phoneNumber"/>
              </b-form-group>
              <b-form-group label="Data di inizio">
                <DatePicker ref="timestampStart" v-model="filters.timestampStart" id="timestamp-start"
                            :required="false"/>
              </b-form-group>
              <b-form-group label="Data di fine">
                <DatePicker ref="timestampEnd" v-model="filters.timestampEnd" id="timestamp-end"
                            :required="false"/>
              </b-form-group>
              <b-button type="submit" variant="primary" block id="search">
                <b-icon-search/>&nbsp;Cerca
              </b-button>
              <b-button @click="exportCsv" variant="success" block >
                <b-icon-arrow-bar-down/>&nbsp;Download csv
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="10">
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-card-checklist/>&nbsp;Pagamenti completati </strong></span>
            </div>
            <div v-if="searched" class="float-right">
              <h6 v-show="!isEmpty(effectiveFilters)" class="filters-list-head">
                Filtri applicati:
                <b-badge class="filter-badge" v-show="effectiveFilters.customerKey" @click="removeFilter('customerKey')"
                         variant="info" pill tag="button">Codice Cliente:
                  <i>{{ effectiveFilters.customerKey }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.storeKey" @click="removeFilter('storeKey')"
                         variant="info" pill tag="button">Codice Negozio:
                  <i>{{ effectiveFilters.storeKey }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.timestampStart"
                         @click="removeFilter('timestampStart')" variant="info" pill tag="button">Data Inizio:
                  <i>{{ effectiveFilters.timestampStart }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.timestampEnd"
                         @click="removeFilter('timestampEnd')" variant="info" pill tag="button">Data Fine:
                  <i>{{ effectiveFilters.timestampEnd }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.displayName"
                         @click="removeFilter('displayName')" variant="info" pill tag="button">Nome Sensei:
                  <i>{{ effectiveFilters.displayName }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.email"
                         @click="removeFilter('email')" variant="info" pill tag="button">Email:
                  <i>{{ effectiveFilters.email }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="effectiveFilters.phoneNumber"
                         @click="removeFilter('phoneNumber')" variant="info" pill tag="button">Numero di Telefono:
                  <i>{{ effectiveFilters.phoneNumber }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
              </h6>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="71vh" :no-border-collapse="true" responsive :fields="fields" :items="charges">
            <template #cell(actions)="data">
              <b-button-group class="mr-2">
                <b-button @click="data.toggleDetails" size="sm" title="Mostra dettaglo utente" v-b-tooltip.hover variant="info" ref="note">
                  <b-icon-book-half size="sm"/>
                </b-button>
              </b-button-group>
            </template>
            <template #row-details="data">
              <b-row class="mb-2">
                <UserDetail :customerKey="data.item.key"/>
              </b-row>
            </template>
            </b-table>
          </b-card-body>
        </b-card>
        <b-pagination
          align="left"
          v-model="currentPage"
          @change="findCharges"
          :per-page="pageSize"
          :total-rows="totalRows"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sensei from "@/api/AutoshopApi"
import moment from "moment/moment";
import customers from "@/views/Customers.vue";
import UserDetail from "@/components/senseiAnagraphics/UserDetail.vue";
import DatePicker from "@/components/DatePicker.vue";


export default {
  name: 'Charges',
  components: {DatePicker, UserDetail},
  provide() {
    return {parentValidator: this.$validator}
  },
  mounted() {
    this.findCharges(this.currentPage)
  },
  data: () => ({
    fields: [
      {key: "storeKey", label: "Negozio"},
      {key: "timestamp", label: "Data tentativo"},
      {key: "key", label: "Codice cliente"},
      {key: "basketId", label: "Codice Carrello"},
      {key: "paymentProcessor", label: "Processore pagamento"},
      {key: "paymentProcessorAccount", label: "Account pagamento"},
      {key: "invoiceAmount", label: "Imp. fatturato"},
      {key: "outstandingAmount", label: "Imp. dovuto"},
      {key: "chargedAmount", label: "Imp. addebitato"},
      {key: "balance", label: "Bilancio"},
      {key: "currency", label: "Valuta"},
      {key: "actions", label: ''}

    ],
    charges: [],
    searched: false,
    customers,
    currentPage: 1,
    pageSize: 20,
    totalRows: null,
    currentWarning: {
      contractCode: null,
      note: null
    },
    noteSaving: false,
    filters: {
      storeKey: null,
      customerKey: null,
      timestampStart: null,
      timestampEnd: null,
      displayName: null,
      email: null,
      phoneNumber: null,
    },
    effectiveFilters: {}
  }),
  methods: {
    setFilters() {
      if (this.filters.customerKey) this.effectiveFilters.customerKey = this.filters.customerKey.trim()
      if (this.filters.storeKey) this.effectiveFilters.storeKey = this.filters.storeKey.trim()
      if (this.filters.timestampStart) this.effectiveFilters.timestampStart = this.filters.timestampStart.trim()
      if (this.filters.timestampEnd) this.effectiveFilters.timestampEnd = this.filters.timestampEnd.trim()
      if (this.filters.email) this.effectiveFilters.email = this.filters.email.trim()
      if (this.filters.phoneNumber) this.effectiveFilters.phoneNumber = this.filters.phoneNumber.trim()
      if (this.filters.displayName) this.effectiveFilters.displayName = this.filters.displayName.trim()
    },
    findFiltered(event) {
      if (event) {
        event.preventDefault()
      }
      this.currentPage = 1
      this.searched = true
      this.setFilters()

      this.findCharges(this.currentPage)
    },
    findCharges(currentPage) {
      this.currentPage = currentPage
      Sensei.findAllCharges({...this.effectiveFilters, page: this.currentPage, pageSize: this.pageSize})
        .then(charges => {
          this.fillCharges(charges)
          this.searched = !this.isEmpty(this.effectiveFilters)
        })
    },
    fillCharges(charges) {
      charges.charges.forEach((item) => {
        item.timestamp = moment(item.timestamp).format("DD/MM/YYYY HH:mm")
      })

      this.charges = charges.charges
      this.totalRows = charges.rows
    },
    exportCsv() {
      Sensei.downloadCsvCharges({...this.effectiveFilters});
    },
    isEmpty(object) {
      return Object.keys(object).length === 0 || Object.keys(object).every(key => object[key] == null)
    },
    removeFilter(field) {
      delete this.effectiveFilters[field]
      delete this.filters[field]

      if (field === 'timestampStart') {
        this.$refs.timestampStart.reset()
      }
      if (field === 'timestampEnd') {
        this.$refs.timestampEnd.reset()
      }
      this.findCharges(this.currentPage)
    },
  }
}
</script>

<style>
</style>
